import { FC } from 'react';
import { FormProvider } from 'react-hook-form';
import { Flex, Stack } from '@chakra-ui/react';

import {
  DatePicker,
  DebouncedTextInput,
  FormField,
} from '~/core/shared/components';
import { ActivityCauserFilterButtons } from '~/core/shared/components/activities/ActivityCauserFilterButtons';
import { DocumentActivitiesTable } from '~/core/shared/components/activities/DocumentActivitiesTable';
import { useActivitiesTab } from './hooks';

export const ActivitiesTab: FC = () => {
  const {
    form,
    onSearch,
    causerType,
    setCauserType,
    definition,
    applicationUuid,
    searchParams,
  } = useActivitiesTab();

  return (
    <Stack gap={8}>
      <Flex justifyContent="space-between">
        <FormProvider {...form}>
          <Flex alignItems="flex-end" gap={4}>
            <DebouncedTextInput
              borderColor="#CBD5E0"
              borderRadius="0"
              hasIcon
              name="search"
              onDebouncedChange={onSearch}
              placeholder="Search activities"
              variant="outline"
            />

            <FormField
              component={DatePicker}
              label="Start date"
              name="after_date"
            />
            <FormField
              component={DatePicker}
              label="End date"
              name="before_date"
            />
          </Flex>
        </FormProvider>
        <ActivityCauserFilterButtons
          causerType={causerType}
          onCauserChange={setCauserType}
        />
      </Flex>

      <DocumentActivitiesTable
        key={causerType}
        documentDefinition={definition}
        documentId={applicationUuid}
        searchParams={searchParams}
      />
    </Stack>
  );
};
